import axios from 'axios';
import { getMessaging, getToken } from 'firebase/messaging';

export const CheckAndUpdateFCMToken = async (userId) => {
  try {
    const currentToken = await getToken(getMessaging, {
      vapidKey:
        'BOnV3OPr8NtdAAFOblZEihI98FMCCn0jC_t_lkdAZ6h2brGdh2eHt6BjFeDTm8pE1YGYtbE_0EGThXUZR6XpTc4', // هات الـ VAPID key من Firebase Console > Cloud Messaging
    });

    if (currentToken) {
      // ابعت الـ token للسيرفر عند كل فتح
      await axios.post(`api/v1/Notification/send-fcm`, {
        userId,
        fcmToken: currentToken,
      });

      console.log('✅ Token verified and updated:', currentToken);
    } else {
      console.log('⚠️ No token available. Request permission to generate one.');
    }
  } catch (error) {
    console.error('❌ Error getting or sending FCM token:', error);
  }
};
